module.exports = __webpack_public_path__ + "img/computer-icon-white.a5cd0f7e.svg";